import React from 'react';
import PropTypes from 'prop-types';
import _ from "lodash";
import RunIdLink from "./RunIdLink";

const RunId = ({row}) => {
    const listItems = _.uniq(
        row.original.details
            .filter(task => task.status === "Failure")
            .map(task => task.taskId)
    ).map(taskId => taskId)
    return <>
        <RunIdLink {...row}/>
        {!_.isEmpty(listItems) && <>
            <br/>
            <a target={'_blank'}
               id={'confluence-link'}
               href={'https://spins.atlassian.net/wiki/spaces/PO/pages/6224379947/Sales+Ingestion+DAG+failure+resolutions'}
               rel={'noopener noreferrer'}>
                {listItems}
            </a>
        </>}
    </>
}

RunId.propTypes = {
    row: PropTypes.object
};

export default RunId;